export enum EnumTenantUserStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  WAITING_APPROVAL = "WAITING_APPROVAL",
}
